import "bitecs";
import "../ecs/components.js";
import { toCamelCase as A } from "../utils/naming.js";
import { formatUnknownElement as b, formatUnknownAttribute as j } from "./diagnostics.js";
import { ParseContext as R } from "./parse-context.js";
import { parseComponentProperties as P } from "./property-parser.js";
import { expandShorthands as v } from "./shorthand-expander.js";
import "three";
import "../validation/schemas.js";
function O(o) {
  return typeof o == "number" ? o : typeof o == "string" ? parseFloat(o) || 0 : typeof o == "boolean" && o ? 1 : 0;
}
function E(o, r, c, t) {
  const s = o.getRecipe(r);
  if (!s) {
    const e = Array.from(o.getRecipeNames()), n = b(r, e);
    throw new Error(n);
  }
  const i = o.createEntity();
  if (s.components)
    for (const e of s.components) {
      const n = o.getComponent(e);
      n && o.addComponent(i, n);
    }
  if (s.components)
    for (const e of s.components) {
      const n = o.getComponent(e);
      if (n) {
        const m = o.config.getDefaults(e);
        for (const [f, a] of Object.entries(m))
          f in n && (n[f][i] = a);
      }
    }
  if (s.overrides)
    for (const [e, n] of Object.entries(s.overrides)) {
      const [m, f] = e.split("."), a = o.getComponent(m);
      if (a) {
        o.hasComponent(i, a) || o.addComponent(i, a);
        const l = A(f);
        l in a && (a[l][i] = n);
      }
    }
  return F(i, s, c, o, t), i;
}
function M(o, r, c = {}) {
  const t = new R(o);
  return E(o, r, c, t);
}
function w(o, r, c, t) {
  const s = A(c);
  return s in r ? (r[s][o] = O(t), !0) : !1;
}
function $(o, r, c, t, s) {
  if (c.includes(".")) {
    const [i, e] = c.split("."), n = s.getComponent(i);
    return n ? w(
      o,
      n,
      e,
      t
    ) : !1;
  }
  if (r.components)
    for (const i of r.components) {
      const e = s.getComponent(i);
      if (e && w(
        o,
        e,
        c,
        t
      ))
        return !0;
    }
  if (r.components) {
    const i = typeof t == "string" ? t : String(t);
    for (const e of r.components) {
      const n = s.config.getAdapter(e, c);
      if (n)
        return n(o, i, s), !0;
    }
  }
  return !1;
}
function k(o, r) {
  const c = /* @__PURE__ */ new Set();
  if (o.components)
    for (const t of o.components) {
      const s = r.config.getShorthands(t);
      for (const e of Object.keys(s))
        c.add(e);
      const i = r.config.getAdapterProperties(t);
      for (const e of i)
        c.add(e);
    }
  for (const t of r.getComponentNames())
    c.add(t);
  if (o.components)
    for (const t of o.components) {
      const s = r.getComponent(t);
      if (s) {
        c.add(t);
        for (const i in s)
          if (typeof s[i] != "function" && !i.startsWith("_")) {
            const e = i.replace(/([A-Z])/g, "-$1").toLowerCase();
            c.add(`${t}.${e}`), c.add(e);
          }
      }
    }
  return c.add("id"), c.add("name"), Array.from(c).sort();
}
function F(o, r, c, t, s) {
  const i = v(c, r, t);
  for (const n of t.config.getValidations())
    n.condition(r.name, i) && console.warn(`[${r.name}] Warning: ${n.warning}`);
  const e = !!t.getParser(r.name);
  for (const [n, m] of Object.entries(i)) {
    if (n === "id") continue;
    if (n === "name") {
      typeof m == "string" && s.setName(m, o);
      continue;
    }
    const f = t.getComponent(n);
    if (f && typeof m == "string") {
      if (!t.hasComponent(o, f)) {
        t.addComponent(o, f);
        const l = t.config.getDefaults(n);
        for (const [p, g] of Object.entries(l))
          p in f && (f[p][o] = g);
      }
      const a = P(
        n,
        m,
        f,
        t,
        s,
        o
      );
      for (const [l, p] of Object.entries(a))
        l in f && (f[l][o] = p);
    } else if (!$(
      o,
      r,
      n,
      m,
      t
    ) && !e && !s.shouldIgnoreUnknownAttribute(n)) {
      const l = k(r, t), p = [];
      if (r.components)
        for (const h of r.components) {
          const d = t.config.getShorthands(h);
          p.push(...Object.keys(d));
        }
      for (const [h] of Object.entries(i))
        if (t.getComponent(h)) {
          const d = t.config.getShorthands(h);
          for (const u of Object.keys(d))
            p.includes(u) || p.push(u);
        }
      const g = j(
        n,
        r.name,
        l,
        p
      );
      console.warn(g);
    }
  }
}
function X(o, r, c) {
  const t = [], s = new R(o, c);
  function i(e) {
    if (o.hasRecipe(e.tagName)) {
      const n = E(
        o,
        e.tagName,
        e.attributes,
        s
      ), m = o.getParser(e.tagName);
      if (m)
        return m({ entity: n, element: e, state: o, context: s }), { entity: n, tagName: e.tagName, children: [] };
      const f = [];
      for (const a of e.children) {
        const l = o.getParser(a.tagName);
        if (l)
          l({ entity: n, element: a, state: o, context: s });
        else if (o.hasRecipe(a.tagName)) {
          const p = i(a);
          if (p) {
            f.push(p);
            const g = p.entity, h = o.getComponent("parent"), d = o.getComponent("transform");
            if (h && d) {
              if (!o.hasComponent(n, d)) {
                console.warn(
                  `[${e.tagName}] Parent entity is missing Transform component. Adding automatically.
  Consider adding transform="pos: 0 0 0" to the parent element.`
                ), o.addComponent(n, d);
                const y = o.config.getDefaults("transform");
                for (const [N, C] of Object.entries(y))
                  N in d && (d[N][n] = C);
              }
              if (!o.hasComponent(g, d)) {
                console.warn(
                  `[${a.tagName}] Child entity is missing Transform component. Adding automatically.
  Consider adding transform="pos: 0 0 0" to the child element.`
                ), o.addComponent(g, d);
                const y = o.config.getDefaults("transform");
                for (const [N, C] of Object.entries(y))
                  N in d && (d[N][g] = C);
              }
              o.addComponent(g, h), h.entity[g] = n;
              const u = o.getComponent("body");
              u && o.hasComponent(n, u) && o.hasComponent(g, u) && console.warn(
                `[Physics Warning] "${a.tagName}" has a Body component and is nested inside "${e.tagName}" which also has a Body component.
This configuration is not supported - a physics body should not be a child of another physics body.
Consider one of these solutions:
  1. Remove the Body component from the child (keep only Collider if needed)
  2. Make "${a.tagName}" a sibling of "${e.tagName}" instead of a child
  3. Use physics constraints or joints to connect separate bodies`
              );
            }
          }
        } else {
          const p = Array.from(o.getRecipeNames()), g = b(
            a.tagName,
            p
          );
          throw new Error(
            g + `
  Note: Components must be specified as attributes, not child elements.
  Example: <entity transform="pos: 0 5 0" renderer="shape: box"></entity>`
          );
        }
      }
      return {
        entity: n,
        tagName: e.tagName,
        children: f
      };
    }
    return null;
  }
  if (r.children.length > 0)
    for (const e of r.children) {
      const n = i(e);
      if (n)
        t.push(n);
      else {
        const m = Array.from(o.getRecipeNames()), f = b(e.tagName, m);
        throw new Error(f);
      }
    }
  else {
    if (r.tagName === "world")
      return t;
    const e = i(r);
    if (e)
      t.push(e);
    else {
      const n = Array.from(o.getRecipeNames()), m = b(
        r.tagName,
        n
      );
      throw new Error(m);
    }
  }
  return t;
}
export {
  M as createEntityFromRecipe,
  X as parseXMLToEntities
};
//# sourceMappingURL=parser.js.map
